export const site = {
  brand: "吃瓜大赛",
  org: "瓜友档案馆",
  season: "2026",
  slogan: "今年的瓜，一个都不许烂在藤上。",
  email: "hello@chigua-dasai.example",
  wechat: "guayou-danganguan",
  desc: "吃瓜大赛是瓜友档案馆发起的年度网络热点盘点盛事，面向全网瓜友征集并评选年度最具话题度、最有后劲的候选瓜料。选手盘点、参赛名单、热门选手与种子选手信息全公开。",
};

export const heroStats = [
  { value: "24", label: "入围瓜料" },
  { value: "6", label: "晋级赛区" },
  { value: "920", label: "万+ 累计投票" },
  { value: "3.8", label: "亿围观人次" },
];

export const tickers = [
  "瓜王之争进入冲刺期，最终战将于 9 月 12 日收官",
  "红毯连环反转票数断层登顶，暂列种子第一",
  "最强黑马候选人浮出水面：一匹从海选逆袭的小城文旅",
  "观赛加时赛通道已开启，每日签到可领双倍瓜币",
  "组委会已开放瓜料申诉，选手资料如有出入可提交修正",
];

export const categories = [
  { id: "yule", name: "娱乐圈", icon: "ri-mic-line", desc: "红毯、选秀与饭圈名场面" },
  { id: "tiyu", name: "体育圈", icon: "ri-trophy-line", desc: "赛场争议与转会暗流" },
  { id: "shangye", name: "商业圈", icon: "ri-briefcase-line", desc: "联名营销与创始人口径" },
  { id: "keji", name: "科技圈", icon: "ri-cpu-line", desc: "发布会翻车与宕机时刻" },
  { id: "dianshang", name: "直播电竞", icon: "ri-gamepad-line", desc: "主播整活与赛场爆冷" },
  { id: "shehui", name: "社会民生", icon: "ri-earth-line", desc: "消费热点与文旅爆火" },
];

export const contestants = [
  {
    id: "y1",
    category: "yule",
    name: "年度音乐盛典·红毯造型连环反转",
    tag: "红毯名场面",
    heat: 96,
    seed: true,
    dark: false,
    summary: "多套造型上线又删、团队口径反复横跳，网友考古出三年前采访被反杀，票数断层领跑，稳居本届头号种子。",
  },
  {
    id: "y2",
    category: "yule",
    name: "成团夜·实时票池数据疑云",
    tag: "选秀票数",
    heat: 88,
    seed: true,
    dark: false,
    summary: "成团夜最后十分钟票差剧烈跳动，各路瓜友连夜做数据模型，把“算法究竟如何计票”送上热门话题第一位。",
  },
  {
    id: "y3",
    category: "yule",
    name: "综艺密室·临时换角风波",
    tag: "综艺观察",
    heat: 76,
    seed: false,
    dark: true,
    summary: "开录前一周核心嘉宾突然被换，制作组以“档期冲突”回应，却被扒出撞档同一档新节目，舆论一路追更。",
  },
  {
    id: "t1",
    category: "tiyu",
    name: "总决赛压哨绝杀·裁判回看争议",
    tag: "赛场争议",
    heat: 90,
    seed: true,
    dark: false,
    summary: "终场前 0.8 秒的压哨球经过三次回看才定档，赛后名宿与网友各执一词，成为体育圈最坚挺的瓜源。",
  },
  {
    id: "t2",
    category: "tiyu",
    name: "明星球员转会·更衣室暗流",
    tag: "转会内幕",
    heat: 82,
    seed: false,
    dark: false,
    summary: "官宣与流言相差一个赛季，经纪人先后两套说辞，队友直播时一句“不好评价”再添一把火。",
  },
  {
    id: "t3",
    category: "tiyu",
    name: "老将复出首秀·竞技状态成谜",
    tag: "复出观察",
    heat: 64,
    seed: false,
    dark: true,
    summary: "阔别两年宣布复出，首秀数据平庸却引发两极评价：是英雄迟暮还是状态还在磨合？观望情绪浓厚。",
  },
  {
    id: "s1",
    category: "shangye",
    name: "国民品牌跨界联名·开售即崩",
    tag: "联名营销",
    heat: 84,
    seed: true,
    dark: false,
    summary: "万物皆可联名玩到头部国民品牌，开售十分钟官网宕机、黄牛价翻五倍，反向把营销事故吃成了热门瓜。",
  },
  {
    id: "s2",
    category: "shangye",
    name: "创始人直播翻车·口径全面反转",
    tag: "创始人口径",
    heat: 72,
    seed: false,
    dark: true,
    summary: "直播里一句“真心话”被切片疯传，随后公关稿改了三版，从“失言”到“被断章取义”，网友吃瓜不亦乐乎。",
  },
  {
    id: "s3",
    category: "shangye",
    name: "新消费融资绯闻·估值玄学",
    tag: "融资动态",
    heat: 60,
    seed: false,
    dark: false,
    summary: "一份未经证实的融资清单在行业群流传，估值传闻从小道消息一路扩散，公司至今未正面回应。",
  },
  {
    id: "k1",
    category: "keji",
    name: "旗舰发布会·参数宣传翻车",
    tag: "数码评测",
    heat: 78,
    seed: true,
    dark: false,
    summary: "发布会现场跑分与实测出现差距，自媒体连夜复测，性能调度之争成为科技圈讨论最久的话题。",
  },
  {
    id: "k2",
    category: "keji",
    name: "AI 新功能抢先体验·用户整活大赛",
    tag: "AI 玩法",
    heat: 70,
    seed: false,
    dark: true,
    summary: "一款新 AI 功能灰度开放后，网友用离谱提示词反向调教，整活作品反哺官方社区，演变成全民二创。",
  },
  {
    id: "k3",
    category: "keji",
    name: "云服务故障·全网排队名场面",
    tag: "宕机现场",
    heat: 66,
    seed: false,
    dark: false,
    summary: "核心服务中断半小时，各平台排队动画刷屏，#今天我排队了没# 意外成为当天的快乐源泉。",
  },
  {
    id: "d1",
    category: "dianshang",
    name: "头部主播复播首日·弹幕狂欢",
    tag: "主播生态",
    heat: 86,
    seed: true,
    dark: false,
    summary: "沉寂数月后的首场直播，开播三分钟挤爆服务器，弹幕与礼物齐飞，一夜之间重回话题顶点。",
  },
  {
    id: "d2",
    category: "dianshang",
    name: "世界赛 BP 大爆冷·BP 被点菜",
    tag: "电竞赛场",
    heat: 74,
    seed: false,
    dark: false,
    summary: "夺冠热门的阵容选择被对手全面克制，赛后复盘贴两天破百万阅读，教练组决策成为全民讨论对象。",
  },
  {
    id: "d3",
    category: "dianshang",
    name: "手游新版本·数值平衡争议",
    tag: "游戏更新",
    heat: 58,
    seed: false,
    dark: true,
    summary: "一次大版本改动把冷门角色捧上神坛，老玩家与新人吵成一团，版本“真神”是谁至今没有定论。",
  },
  {
    id: "h1",
    category: "shehui",
    name: "城市现象级排队·消费新热点",
    tag: "线下消费",
    heat: 80,
    seed: true,
    dark: false,
    summary: "一座以创意市集出圈的小城，周末限号排队仍一票难求，成为实体消费回暖最鲜活的注脚。",
  },
  {
    id: "h2",
    category: "shehui",
    name: "文旅小城爆火·游客攻占记",
    tag: "文旅热点",
    heat: 68,
    seed: false,
    dark: true,
    summary: "一条不到一分钟的旅拍视频带火整座小城，本地人一边喊“别来了”一边加入摆摊，话题后劲十足。",
  },
  {
    id: "h3",
    category: "shehui",
    name: "全民整活挑战·二创狂欢",
    tag: "网络文化",
    heat: 62,
    seed: false,
    dark: false,
    summary: "一个无厘头挑战在短视频平台裂变出上百种玩法，全民参与度极高，被评为本届最“下饭”的瓜。",
  },
];

export const seeds = [
  {
    name: "红毯造型连环反转",
    category: "yule",
    heat: 96,
    note: "断层票王",
    insight: "连续三轮反转，话题生命周期超长，被瓜友称为“本届续航最久的名场面”。",
  },
  {
    name: "裁判回看争议",
    category: "tiyu",
    heat: 90,
    note: "理性之瓜",
    insight: "硬核球迷与路人各执一词，是少有的“能吵一个夏天”的理性向瓜源。",
  },
  {
    name: "主播复播首夜",
    category: "dianshang",
    heat: 86,
    note: "流量之巅",
    insight: "开播三分钟流量登顶，商业价值与话题度双开花，最具“破圈”潜力的选手。",
  },
  {
    name: "联名开售即崩",
    category: "shangye",
    heat: 84,
    note: "品牌奇案",
    insight: "营销事故反向出圈，是营销人眼中“可写进教科书”的经典案例。",
  },
];

export const timeline = [
  { phase: "海选提名期", range: "7.15 — 7.31", desc: "面向全网征集年度候选瓜料，组委会初审后公布完整参赛名单。" },
  { phase: "初赛投票期", range: "8.01 — 8.20", desc: "六大赛区并行开票，瓜友每日可投，各赛区热度前三进入晋级区。" },
  { phase: "半决赛加时", range: "8.21 — 9.05", desc: "晋级选手进入深度盘点，新增“反转加时”与黑马投票池。" },
  { phase: "瓜王之夜", range: "9.12", desc: "年度瓜王终极对决现场公布，揭晓瓜王、最强黑马与人气之选。" },
];

export const stats = [
  { value: "24", suffix: "条", label: "本届入围候选瓜料" },
  { value: "6", suffix: "大赛区", label: "并行晋级的投票赛道" },
  { value: "920", suffix: "万+", label: "瓜友累计投出的票数" },
  { value: "3.8", suffix: "亿", label: "围观人次再创新高" },
];

export const awards = [
  { icon: "ri-award-line", title: "年度瓜王", desc: "综合热度与话题生命力的年度最高殊荣" },
  { icon: "ri-rocket-2-line", title: "最强黑马", desc: "从海选一路逆袭、后劲最足的新面孔" },
  { icon: "ri-heart-3-line", title: "人气之选", desc: "完全由瓜友票选投出的民心向冠军" },
  { icon: "ri-flashlight-line", title: "反转之星", desc: "反转最多、最让人意想不到的剧情王" },
];

export const faqs = [
  {
    q: "吃瓜大赛到底是什么？",
    a: "吃瓜大赛是瓜友档案馆发起的年度网络热点盘点盛事，面向全网征集年度最具话题度的候选瓜料，再通过多赛区投票、深度盘点与终极对决，评选出当年的“瓜王”。它更像一张全民投票的年度热点榜单。",
  },
  {
    q: "参赛名单里的“选手”是什么？",
    a: "这里的“选手”指入围的候选瓜料，也就是本年度最有讨论度的娱乐、体育、商业、科技等各类热点事件与名场面。每个赛区会提名并盘点若干条瓜料，供瓜友投票、围观与持续追更。",
  },
  {
    q: "种子选手和最强黑马是怎么选的？",
    a: "种子选手综合参考了事件的热度值、话题持续时间和全网讨论深度，由组委会结合公开数据初筛后公布。最强黑马则主要看后劲——那些前期关注度一般、却在一段时间内持续发酵、票数快速上涨的选手，最有机会成为黑马。",
  },
  {
    q: "我的瓜料没有上榜，可以参赛吗？",
    a: "当然可以。瓜友可以在页面底部的“提交你的瓜”表单里推荐候选事件，组委会会择优补入海选池。越具体、有实锤、讨论度越高的瓜料，越容易获得提名资格。",
  },
  {
    q: "投票规则是怎么样的？",
    a: "初赛期间每个赛区每天可投，晋级规则以各赛区累计票数为主。半决赛新增“反转加时”与黑马投票池，决赛阶段每张票对瓜王归属都有直接影响。具体时间轴与晋级安排以赛程区块公示为准。",
  },
  {
    q: "为什么我的留言在评论区消失了？",
    a: "为保证讨论氛围，涉及人身攻击、辱骂或未经证实的隐私爆料会被自动折叠或移除。吃瓜讲证据、不辱骂是我们一以贯之的原则，感谢每一位理性吃瓜的瓜友共同维护现场秩序。",
  },
];

export const joinSteps = [
  { step: "01", title: "找到那颗好瓜", desc: "提名你心中今年最有后劲、最有讨论度的候选事件，附上线索更佳。" },
  { step: "02", title: "填写报名信息", desc: "留下称谓与联系方式，组委会会在 3 个工作日内完成审核回执。" },
  { step: "03", title: "坐等吃瓜上榜", desc: "审核通过即进入海选池，有机会冲进正式参赛名单一较高下。" },
];